import { classnames } from '@aibees/shared/utils';
import { Box, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import { humanReadableLanguageProficiency } from '../../utils';
import * as SX from './sx';
import type { LanguagesItemProps as Props } from './types';

export const LanguagesItem = memo(({ className, item, index }: Props) => {
  return (
    <Box
      className={classnames('LanguagesItem', className)}
      sx={SX.root}
      key={index}
    >
      <Stack direction="column" gap={0.25}>
        <Typography variant="h6">{item.name}</Typography>

        <Typography variant="body4" color="grey.500">
          {humanReadableLanguageProficiency(item.proficiency)}
        </Typography>
      </Stack>
    </Box>
  );
});

LanguagesItem.displayName = 'LanguagesItem';
